import React, { useState, useEffect } from 'react'
import './ColorPanel.scss';
import ColorBox from '../ColorBox/ColorBox';
import SaveModal from '../SaveModal/SaveModal';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import axios from 'axios';
import Load from '../Canvas/Load';

export default function ColorPanel({sendColor, getLoad}) {
    //currentUser is the object returned from firebase when a user is logged in
    const { currentUser } = useAuth();
    //Saved palette is a placeholder to get specific color from each mapped ColorBox component
    const savedPalette = [];
    //State Hooks
    const paletteInput = ["N", "N", "N", "N", "N"];
    //Default state for the API call to fill in -- for first generated palette upon loading
    const [defaultColors, setDefaultColors] = useState([]);
    //a flag to allow loading animation while waiting for API call return
    const [loading, setLoading] = useState(true);
    //Modal activation
    const [showSaveModal, setSaveModal] = useState(false);
    //State to pass palette information to the Save Modal to complete post to API
    const [paletteInfo, setPaletteInfo] = useState({})
    //theme context 
    const darkTheme = useTheme();
    //On mount, we call the API for a random color palette
    useEffect(()=> {
        const random = {"model": "default"}
        // axios.post('https://blooming-depths-76471.herokuapp.com/random', random)
        axios.post('https://blooming-depths-76471.herokuapp.com/random', random)
        .then(res=>{
            setDefaultColors(res.data.result)
            setLoading(false)
        })
    },[])
    
    //on click to generate new random palette
    const handleGenerate = () => {
        setLoading(true)
        getLoad(true)
        let lockedColors = JSON.stringify(paletteInput)
        const random = {"model": "default"}
        const input = {"input": paletteInput, "model": "default"}
       
        // axios.post('https://blooming-depths-76471.herokuapp.com/random', ((lockedColors === '["N","N","N","N","N"]') ? random : input))
        axios.post('https://blooming-depths-76471.herokuapp.com/random', ((lockedColors === '["N","N","N","N","N"]') ? random : input))
        .then(res=>{
            setDefaultColors(res.data.result)
            sendColor(res.data.result)
            setTimeout(()=> {
                setLoading(false)
                getLoad(false)
            }, 1000)
            
        })
        .catch(err => {
            console.log(err);
        })
    }

    //Passes palette information and shows SaveModal 
    //Step 1 of 2 to save your palette
    const handleSave = () => {
        setSaveModal(true);
        const userId = currentUser.uid
        const palettePost = {
            user_id: userId,
            user_name: currentUser.email,
            color1: savedPalette[0],
            color2: savedPalette[1],
            color3: savedPalette[2],
            color4: savedPalette[3],
            color5: savedPalette[4],
        }
        //this allows SaveModal to get paletteInfo from this component
        setPaletteInfo(palettePost)
    }

    //When the color of ColorBox is changed, this populates savedPalette
    //This function is passed down as a prop to ColorBox
    function getHex(col, index){
        savedPalette[index] = col
    }
    //this gets the color that is locked by user
    const getInput = (col, index) => {
        paletteInput[index] = col
    }
    
    const closeModal = () => {
        setSaveModal(false);
    }
    
    return (
        <>     
            <div onRender={sendColor(defaultColors)}className="colorpanel__container">
                 
                <div className="colorbox"> 
                {(!loading) ? (
                    defaultColors.map((color, i) => {

                        return (<ColorBox key={i} index={i} defColour={color} handleHex={getHex} getInput={getInput}/>)
                    })
                ) 
                : <Load />}
                    
                </div>
                <div className="colorpanel__btn">
                    <button className={(darkTheme) ? "colorpanel__generate-dark" : "colorpanel__generate"} onClick={handleGenerate}>Generate</button>
                    {(currentUser) ? <button className={(darkTheme) ? "colorpanel__save-dark" : "colorpanel__save"}onClick={handleSave}>Save</button> : null}
                </div>
            </div>
            {(showSaveModal) ? <SaveModal data={defaultColors} post={paletteInfo} close={closeModal}/> : null}
        </>
    )
}
